import type {StaffActivityAlertData} from "./staff-activity-contract";

/** Never navigate using a server-supplied free-form URL. Fail closed for report access. */
export function staffActivityAlertDestination(activity:StaffActivityAlertData|undefined,canActivity:boolean){
  if(!activity)return null;
  if(activity.audience==="finance")return canActivity?{path:"/staff/activity",teamCheckBranchId:null}:null;
  const paths:Record<string,string>={team_check:"/staff",pay:"/staff/pay",employee_update:"/staff/employees",bonus:"/staff/bonuses",advance:"/staff/advances",deduction:"/staff/deductions",employee_add:"/staff/employees",end_service:"/staff/employees",move:"/staff/employees",papers:"/staff/employees",certificates:"/staff/bonuses",settings:"/staff"};
  const path=activity.feature?paths[activity.feature]:"/staff";
  if(!path)return null;
  const branch=activity.branchId?`?branch=${encodeURIComponent(activity.branchId)}`:"";
  return {path:`${path}${branch}`,teamCheckBranchId:activity.feature==="team_check"?activity.branchId:null};
}
